var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderProductPriceList',{attrs:{"img_header":_vm.header_image,"header":"ตารางราคาสินค้า (Product price list)","link_back":"warehouse","check_link_back":"1"}}),_c('ProductPriceList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }